import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../api/client';

interface Project { id: number; title: string; description: string; }
interface Activity { id: number; title: string; description: string; }

export default function ActivityPage() {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const title = searchParams.get('title') || '';
  const [activity, setActivity] = useState<Activity | null>(null);
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!title) return;
    axios.get(`${API_BASE}/activities/get-all-titles`).then(async res => {
      const titles: string[] = res.data;
      const index = titles.findIndex(t => t === title);
      if (index === -1) { setLoading(false); return; }
      const id = index + 1;
      try {
        const [actRes, projRes] = await Promise.all([
          axios.get(`${API_BASE}/activities/get-by-id/${id}`),
          axios.get(`${API_BASE}/activities/get-all-activity-project-by-id/${id}`),
        ]);
        setActivity(actRes.data);
        setProjects(projRes.data);
      } catch {}
      setLoading(false);
    });
  }, [title, i18n.language]);

  if (loading) return <div style={s.loading}>{t('activity_loading')}</div>;
  if (!activity) return <div style={s.loading}>{t('activity_not_found')}</div>;

  return (
    <div style={s.page}>
      <h1 style={s.title}>{activity.title}</h1>
      <p style={s.description}>{activity.description}</p>
      {projects.length > 0 && (
        <section>
          <h2 style={s.projectsTitle}>{t('activity_projects')}</h2>
          <div style={s.projectsGrid}>
            {projects.map(p => (
              <div key={p.id} style={s.projectCard}>
                <h3 style={s.projectTitle}>{p.title}</h3>
                <p style={s.projectDesc}>{p.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  page: { maxWidth: 900, margin: '0 auto', padding: '48px 40px' },
  loading: { textAlign: 'center', padding: 80, color: '#888' },
  title: { fontSize: '2rem', color: '#1a3a6b', marginBottom: 20 },
  description: { fontSize: '1.05rem', color: '#444', lineHeight: 1.8, marginBottom: 40 },
  projectsTitle: { fontSize: '1.4rem', color: '#1a3a6b', marginBottom: 20, paddingBottom: 10, borderBottom: '2px solid #1a3a6b' },
  projectsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 20 },
  projectCard: { background: '#fff', borderRadius: 10, padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #1a3a6b' },
  projectTitle: { fontSize: '1rem', color: '#1a3a6b', marginBottom: 10 },
  projectDesc: { fontSize: '0.9rem', color: '#555', lineHeight: 1.6 },
};
